// Pure (no DOM, no SDK runtime): turns /api/training/practice/start's answer into retell-client-js-sdk 3.x's
// StartCallConfig the same way the SDK's own WebCallSession does with a create-web-call response:
//   { accessToken, transport, callId, url, iceServers }
// transport is always said out loud (the SDK warns the livekit and gateway tokens look alike), url is kept when
// Retell names a LiveKit room server (the SDK's hardcoded host is only the default), and ICE servers go to gateway.
import type { StartCallConfig } from 'retell-client-js-sdk';
import type { PracticeStartResponseExt, PracticeTransport } from '../../../src/shared/api-ai';

/** retell-client-js-sdk 3.x's RetellWebClient joins both. */
export const PRACTICE_TRANSPORTS: PracticeTransport[] = ['livekit', 'gateway'];

export function startCallConfig(start: Pick<PracticeStartResponseExt, 'accessToken' | 'callId' | 'transport' | 'url' | 'iceServers'>): StartCallConfig {
  const config: StartCallConfig = { accessToken: start.accessToken, transport: start.transport ?? 'livekit', callId: start.callId };
  if (start.url) config.url = start.url;
  if (start.iceServers && start.iceServers.length) config.iceServers = start.iceServers;
  return config;
}
